import React__default from 'react';
import classNames from 'classnames';
import { variationName } from '../../../../../../utilities/css.mjs';
import styles from './Item.scss.mjs';

function Item({
  children,
  offset,
  grow = false
}) {
  const itemClassNames = classNames(styles.Item, offset && styles[variationName('offset', offset)], {
    [styles.grow]: grow
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: itemClassNames
  }, children);
}

export { Item };
